// The cast for the "roll the credits" easter egg (Konami code in the signed-in app).
// Seeded from the top contributors in git history, ordered by commit count. This is
// a plain list so anyone can add their own name in a follow-up PR — just append it.

export const contributors: string[] = [
  "Stephen O'Brien",
  "Eoghan Reid",
  "Colin O'Brien",
  "Julia Grabos",
  "Joe Donovan",
  "Shayon Mukherjee",
  "Andrew Katz",
  "William Tabi",
  "Eoin Hennessy",
  "Kyle Rippee",
  "Rosie Halpin",
  "Conor Broderick",
  "Aron Day",
  "Conor O'Donnell",
  "Andras Gombosi",
  "Joseph Korany",
  "Nicolas Waissbluth",
  "Sofie Gundersen",
  "Eoin Hinchy",
  "Yannick Gloster",
  "Austin Halpin",
  "Daire Finn",
  "Greg Merritt",
  "Braddy Yeoh",
  "Brian Long",
  "Cian Mac Mahon",
  "Harvey Gleeson",
  "Liam Croash",
  "Mark Rechler",
  "Nico Gonzalez",
];
